// extracted by mini-css-extract-plugin
export var description = "stay-in-touch-module--description--IyRXv";
export var wrapper = "stay-in-touch-module--wrapper--N5rin";